import GetSurveysRepository from '@/domain/repositories/SurveysRepository';
import SurveysValidationDataStoreFactory from '../factories/SurveysDataStoreFactory';
import GetSurveysDataStore from '../datastores/GetSurveysDataStore';

export default class GetSurveysDataRepository implements GetSurveysRepository {
  getSurveysValidation() {
    const surveyDataStore: GetSurveysDataStore =
      SurveysValidationDataStoreFactory.create();
    return surveyDataStore.getSurveysValidation();
  }
}
